<template>
  <div>
    <header class="n-fixed-top">
      <div class="left" v-if="this.$route.name == 'video_d' || this.$route.name == 'tuwen_d' || this.$route.name == 'minitest' || this.$route.name == 'headVideo_d' || this.$route.name == 'footVideo_d'" @click="back">
        {{$t('pageBack')}}
      </div>
      <div class='landscape-left' v-else></div>
      <slot></slot>
      <div class="right class-ctrl">
        <div class="zhangjie" v-show="scaleState">
          <!-- {{chapterNumCurs+1}}/{{chapterNumAlls}} -->
          <div class="fatherdiv">
              <div class="persentdiv">
                  <div class="persentleft"></div>
                  <div class="persentright wth0"></div>
              </div>
              <div class="num">
                  0%
              </div>
          </div>

        </div>
      </div>
    </header>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      isshowList: false, // 显示隐藏列表
      chapterNumAlls: 0, // 总小节数
      chapterNumCurs: 0 // 当前小节数

    }
  },
  props: {

  },
  computed: {
    ...mapState({
      studyProgress: state => state.studyProgress
    }),
    cur_data () {
      return this.$store.state.cur_data
    },
    chapterNumCur () {
      return this.$store.state.chapterNumCur
    },
    chapterNumAll () {
      return this.$store.state.chapterNumAll
    },
    cur_chap_index () {
      return this.$store.state.currentChapterIndex
    },
    cur_part_index () {
      return this.$store.state.currentPartIndex
    },
    scaleState () {
      return this.$store.state.scaleState
    }
  },
  created () {
    // 小节数显示
    let chapterNum = 0
    data.part_list.forEach((e, i) => {
      this.chapterNumAlls += e.chapter_list.length
      if (this.cur_part_index > i) {
        chapterNum += parseInt(e.chapter_list.length)
        // this.chapterNumCurs = parseInt(this.cur_chap_index) + parseInt(e.chapter_list.length)
      }
      if (this.cur_part_index == 0) {
        this.chapterNumCurs = parseInt(this.cur_chap_index)
      } else {
        this.chapterNumCurs = parseInt(this.cur_chap_index) + chapterNum
      }
    })
    this.$store.commit('chapterNumCur', this.chapterNumCurs)
    this.$store.commit('chapterNumAll', this.chapterNumAlls)
  },
  mounted () {
    this.percent(Math.round(this.$store.state.studyProgress * 100))
  },
  watch: {
    chapterNumCur () {
      this.chapterNumCurs = this.$store.state.chapterNumCur
    },
    // 学习小节进度
    progressNumber () {
      return Math.round(this.$store.state.studyProgress * 100)
    },
    studyProgress () {
      // console.log(99999,this.$store.state.studyProgress);
      this.percent(Math.round(this.$store.state.studyProgress * 100))
    }
  },
  methods: {
    // 渲染百分比
    percent (percent) {
      if (percent > 100) {
        percent = 0
        $('.persentdiv').removeClass('clip-auto')
        $('.persentright').addClass('wth0')
      } else if (percent > 50) {
        $('.persentdiv').addClass('clip-auto')
        $('.persentright').removeClass('wth0')
      }
      $('.persentleft').css('transform', 'rotate(' + 3.6 * percent + 'deg)')
      $('.num').text(percent + '%')
    },
    back () {
      // 有数据就拿数据
      const scormId = this.data.scorm_id
      if (localStorage.getItem(scormId + 'lessonLocation')) {
        this.getLessonLocation()
      }
      let type = this.cur_data.chapter_type // 小节类型
      // 竖屏返回判断
      this.$router.push('/h5Dindex')
    }
  }
}
</script>
<style scoped lang="less">
.n-fixed-top {
  font-size: 0.28rem;
  display: flex;
  background-color: #F7F7F7;
  border-bottom: #ccc;
  height: .78rem;
  align-items: center;
  position: relative;
  z-index: 9;
  width: 100%;
  // @media screen and (orientation : portrait){
  //     width: 7.5rem;
  // }
  // @media screen and (orientation : landscape){
  //     width: 99.9%;

  // }
  .landscape-left{
    width: .2rem;
  }
  .left {
    font-size: .24rem;
    margin-left:.2rem;
    color: #252631;
    background: #D8D8D8;
    padding: .05rem .12rem;
    border-radius: .24rem;
    margin-bottom: .02rem;
    min-width: 13%;
    text-align: center;
  }
  .head_r {
    flex:1;
    display: flex;
    align-items:center;
    height: 100%;
    overflow: hidden;
    span{
      width: 1.26rem;
      height:.54rem;
      line-height:.58rem;
      font-size: .26rem;
      padding-right: .3rem;
      text-align: right;
      background: url('../../assets/img/h5/head-xj.png') no-repeat center / contain;
      i.list {
        width: .27rem;
        height:.13rem;
        line-height:.44rem;
        background: url('../../assets/img/h5/head-ml.png') no-repeat center / contain;
        position:absolute;
        top:0.5rem;
        left:50%;
        margin-left:-.14rem;
      }
    }
    h2 {
      display: inline-block;
      font-size:.32rem;
      flex: 1;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 .3rem;
    }
  }
  .right {
    // width:14vw;
    text-align: right;
    .zhangjie {
      font-size: .24rem;
      margin-right: .15rem;
      color: #252631;
      line-height:.7rem;

    }
  }
  h4{
    // flex:2;
    flex: 1;
    color:#252631;
    font-size: .32rem;
    text-align:center;
    letter-spacing: 1px;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding:0 .3rem;
    box-sizing: border-box;
    @media screen and (orientation : portrait){
      max-width: 5.2rem;
    }
  }

}

/* 圆形进度条 */

.fatherdiv{
    width: 0.6rem;
    height: 0.6rem;
    position: relative;
    background-color: #ddd;
    border-radius: 50%;
}
.persentdiv {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    position: absolute;
    clip: rect(0, 0.6rem, 0.6rem, 0.3rem);
}

.persentleft {
    position: absolute;
    width: 0.6rem;
    height: 0.6rem;
    border: 0.04rem solid #005587;
    box-sizing: border-box;
    border-radius: 50%;
    clip: rect(0, 0.3rem, 0.6rem, 0);
}

.persentright {
    position: absolute;
    width: 0.6rem;
    height: 0.6rem;
    border: 0.04rem solid #005587;
    box-sizing: border-box;
    border-radius: 50%;
    clip: rect(0, 0.6rem, 0.6rem, 0.3rem);
}

.wth0 {
    width: 0;
}

.num {
    position: absolute;
    box-sizing: border-box;
    width: 0.52rem;
    height: 0.52rem;
    line-height: 0.52rem;
    text-align: center;
    font-size: 0.2rem;
    left: 0.04rem;
    top:0.04rem;
    border-radius: 50%;
    background-color: #fff;
    color: #005587;
    z-index: 1;
}
.clip-auto {
    clip: rect(auto, auto, auto, auto);
}
</style>
